import { isTextNode } from 'anodum';
import { DEFAULT_BLOCK_TAG, BLOCKQUOTE_ELEMENT } from '../constants/editable-elements';
import textFormatting from '../../text-formatting';
import wrappersTypes from '../../text-formatting/constants/wrappers-types';
import reverseCloneElement from './reverse-clone-element';

const customElementsTagNames = [
  wrappersTypes.decoration.tagName,
  wrappersTypes.customColor.tagName,
];
const wrappers = [BLOCKQUOTE_ELEMENT, DEFAULT_BLOCK_TAG];
const SELECTOR = `:is(${wrappers.join()}) > :is(${customElementsTagNames.join()})`;

const handleCopyCustomElement = (event) => {
  const selection = textFormatting.accessors.getAdvancedSelection();

  const anchorNodeCustomElementWrapper = selection.anchorNode.parentElement.closest(SELECTOR);
  const focusNodeCustomElementWrapper = selection.focusNode.parentElement.closest(SELECTOR);

  if (
    anchorNodeCustomElementWrapper &&
    anchorNodeCustomElementWrapper === focusNodeCustomElementWrapper
  ) {
    event.preventDefault();

    const range = selection.getRangeAt(0);
    const childToAdd = range.cloneContents();
    const firstElementToClone = isTextNode(range.commonAncestorContainer)
      ? range.commonAncestorContainer.parentElement
      : range.commonAncestorContainer;

    let clonedElement = firstElementToClone.cloneNode();
    clonedElement.appendChild(childToAdd);

    if (firstElementToClone !== anchorNodeCustomElementWrapper) {
      clonedElement = reverseCloneElement(
        clonedElement,
        firstElementToClone.parentElement,
        anchorNodeCustomElementWrapper
      );
    }

    event.clipboardData.setData('text/plain', clonedElement.outerText);
    event.clipboardData.setData('text/html', clonedElement.outerHTML);
  }
};

export default handleCopyCustomElement;
